import { render, staticRenderFns } from "./OrderInfoCategoryCard.vue?vue&type=template&id=5c3ebf1a&"
import script from "./OrderInfoCategoryCard.vue?vue&type=script&lang=ts&"
export * from "./OrderInfoCategoryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports